<template>
  <span class="count-badge" :class="colorClass">
    {{ count }}
  </span>
</template>

<script>
export default {
  name: 'CountBadge',
  props: {
    count: {
      type: [Number, String],
      required: true
    },
    color: {
      type: String,
      default: 'black'
    }
  },
  computed: {
    colorClass() {
      return `count-badge--${this.color}`
    }
  }
}
</script>

<style scoped>
.count-badge {
  align-items: center;
  border-radius: 999px;
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 700;
  height: 22px;
  justify-content: center;
  line-height: 1;
  min-width: 22px;
  padding-inline: 7px;
}

.count-badge--black {
  background: #000;
  color: #fff;
}

.count-badge--success {
  background: rgba(var(--v-theme-success), 0.12);
  color: rgb(var(--v-theme-success));
}

.count-badge--warning {
  background: rgba(var(--v-theme-warning), 0.14);
  color: rgb(var(--v-theme-warning));
}

.count-badge--error {
  background: rgba(var(--v-theme-error), 0.12);
  color: rgb(var(--v-theme-error));
}
</style>
